const TYPES = {
  NULL: 'NULL',
  LIST: 'LIST',
  MAP: 'MAP',
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOL: 'BOOL',
  MUTABLE: 'MUTABLE',
  SCALAR: 'SCALAR',
};

function test(data) {
  const type = typeof data;
  if (data == null) {
    return TYPES.NULL;
  }
  if (Array.isArray(data)) {
    return TYPES.LIST;
  }
  if (data.__MUTABLE) {
    return TYPES.MUTABLE;
  }
  if (type === 'object') {
    return TYPES.MAP;
  }
  if (type === 'string') {
    return TYPES.STRING;
  }
  if (type === 'number') {
    return TYPES.NUMBER;
  }
  if (type === 'boolean') {
    return TYPES.BOOL;
  }
  return TYPES.NULL;
}

export default {
  ...TYPES,
  test,
};
